export default function AttachAgendaItemReportFolderController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  oversightDataService
) {
  const vm = this;

  vm.canExpand = vm.status !== 'No Reports Added';
  vm.isExpanded = false;
  vm.reportInstancesLoaded = false;
  vm.handleExpandFolder = _handleExpandFolder;

  function _handleExpandFolder() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshReportInstances();
    }
  }

  function _refreshReportInstances() {
    const dfdRefresh = $q.defer();

    if (!vm.reportInstancesLoaded) {
      vm.reportInstances = vm.reportFolder.reportInstances;

      if ((vm.reportInstances !== null) && (vm.reportInstances.length > 0)) {
        oversightDataService.getAgendaItemReportsByAgendaItem(vm.agendaItemId).then((getAssignedReportsResponse) => {
          const assignedReports = getAssignedReportsResponse.data.result;
          if (assignedReports.length > 0) {
            assignedReports.forEach((assignedReport) => {
              vm.reportInstances.forEach((report) => {
                if ((report.reportInstanceId === assignedReport.reportInstanceId)
                  && (assignedReport.agendaItemId === vm.agendaItemId)) {
                  report.agendaItemReportInstanceId = assignedReport.agendaItemReportInstanceId;
                  report.attached = true;
                }
              });
            });
          }
        });
      }

      vm.reportInstancesLoaded = true;
    }

    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }
}

AttachAgendaItemReportFolderController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'oversightDataService'
];
